<template>
  <div class="applyForCashier" v-if="$route.path==='/checkModule/check/cashier'">
    <d-search :searchData="searchData"
            @searchEvent="searchEvent"
            @resetEvent="resetEvent" />
    <d-lable :tableData='tableData'
            :columnData='columnData'> 
      <template v-slot:status="{ row }">
        <span>{{ $map.screenStatus[row.status] }}</span>
      </template>    
      <template v-slot:action="{ row }">
        <div class="operateClass clickstyle">
          <span v-if="row.status === 2" @click="actionFun(row)">审核</span>
          <span v-else @click="actionFun(row)">查看</span>
        </div>
      </template>      
    </d-lable>
    <d-paging :pager="pager"
            @change="getList" />
  </div>
  <router-view v-else/>
</template>

<script>
import DSearch from '@/components/d-search'
import DLable from '@/components/d-table'
import DPaging from '@/components/d-paging'
export default {
  name: 'ApplyForCashier',
  components: {
    DSearch,
    DLable,
    DPaging
  },
  data () {
    return {
      pager: {
        count: 0,
        page: 1,
        rows: 10,
      },
      searchData: {
        searchItem: [
        {
          label: '姓名',
          value: 'createUserName',
          type: 'commonInput',
          placeholder: '请输入姓名',
        },
        {
          label: '选择店铺',
          value: 'shopIds',
          type: 'linkageSelect',
          placeholder: '请选择',
          options: [],
          optionProps: {
            value: 'id',
            label: 'name',
            children: 'childList'
          }
        }, {
          label: '状态',
          value: 'status',
          type: 'commonSelect',
          placeholder: '请选择',
          options: [
          {
            label: '已通过',
            value: 4
          },
          {
            label: '待审核',
            value: 2
          },
          {
            label: '已驳回',
            value: 3
          }, 
          ],
        }],
        searchBtn: {
          queryBtn: true,
          resetBtn: true
        },
        params: {
          shopIds: []
        }
      },
      columnData: [
        { prop: 'createUserName', label: '姓名' },
        { prop: 'idCard', label: '身份证', },
        { prop: 'mobile', label: '电话' },
        { prop: 'shopNo', label: '店铺号'},
        { prop: 'shopName', label: '店铺名称' },
        { prop: 'status', label: '状态', slotProp: true },
        { prop: 'auditUserName', label: '审核人' },
        { prop: 'createTime', label: '提交日期' },
        { prop: 'action', label: '操作', slotProp: true }
      ],
      tableData: []
    }
  },
  watch: {
    '$route'(to,from){
      if(to.path==='/checkModule/check/cashier'){
        this.pager.page = parseInt(this.$route.query.page) || 1
        this.getList()
      }
    }
  },
  created () {
    this.getShopList()
    this.getList()
  },
  methods: {
    /**
     * 查询点击
     */
    searchEvent () {
      this.pager.page = 1
      this.pager.rows = 10
      this.getList()
    },
    resetEvent () {
      this.pager.page = 1;
      this.pager.rows = 10;
      this.getList()
    },
    /**
     * 获取选择店铺列表
     */
    getShopList () {
      this.$api.check.getFloorShop()
        .then(({ data, code }) => {
          if (code == 200) {
            this.childList = data.childList
            const child = [{
              id: data.id,
              name: data.name,
              childList: data.childList
            }]
            this.searchData.searchItem.forEach(ele => {
              if (ele.type === 'linkageSelect') {
                ele.options = child
              }
            })
          }
        })
    },
    actionFun (column) {
      this.$router.push({ path: '/checkModule/check/cashier/check', query: { id: column.id, page: this.pager.page } })
    },
    getList () {
      const { shopIds, createUserName, status } = this.searchData.params
      const data = {
        createUserName,
        status,
        shopIds: shopIds ? shopIds.join(',') : '',
        pageNum: this.pager.page,
        pageSize: this.pager.rows
      }
      this.$api.checkapi.getCashierListApi(data).then(({ data }) => {
        this.tableData = data.list || []
        this.pager.count = data.total || 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.applyForCashier {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #fff;
  .el-table {
    flex: 1;
    overflow-y: auto;
    margin-top: 20px;
    padding: 0 20px;
  }
  .d-paging {
    margin-top: 50px;
    text-align: center;
  }
  .clickstyle {
    color: #5c6be8;
    cursor: pointer;
  }
  .operateClass span {
    display: inline-block;
    margin: 0 5px;
    text-decoration: underline;
  }
  .operateClass span:first-child {
    margin-left: 0;
  }
}
</style>